import React, { useEffect } from "react"
import { useSelector } from "react-redux"

import { selectScopedByClient } from "../../stores/appSlice"
import BillableAccountTable from "./components/BillableAccountTable"
import BillableAccountForm from "./components/BillableAccountForm"
import BillTable from "../bills/components/BillTable"
import ServiceTable from "../services/components/ServiceTable"
import ServiceForm from "../services/components/ServiceForm"
// import BillTable from "../billableAccounts/components/BillableAccountTable"
import DocumentsTable from "../documents/components/DocumentsTable"
import DocumentForm from "../documents/components/DocumentForm"
import { useParams } from "react-router"
import ImportForm from "../imports/ImportForm"
import Dashboard from "../../features/dashboards/components/Dashboard"
import BillableAccountNotesTable from "./components/BillableAccountNotesTable"
import consumer, { processBillableAccountNoteResponse } from "../../lib/cable"
import BillableAccountHistory from "./components/BillableAccountHistory"
import BulkEditForm from "../bulkEdit/bulkEditForm"

export default function BillableAccountPage({ view, recordSelected }) {
    // console.log(view)
    const scopedByClient = useSelector(selectScopedByClient)

    const { clientId, billableAccountId } = useParams()
    // console.log(billableAccountId)

    // useEffect(() => {
    //     setUpCableConnection()
    // },[billableAccountId])

    const renderView = () => {
        // setUpCableConnection()
        switch (view) {
            case "dashboard":
                // setUpCableConnection()
                return renderDashboard()
            case "index":
                return renderIndex()
            case "form":
                return renderForm()
            case "services":
                return renderServices()
            case "serviceForm":
                return renderServiceForm()
            case "bills":
                // setUpCableConnection()
                return renderBills()
            case "documents":
                return renderDocuments()
            case "documents-form":
                return renderDocumentsForm()
            case "import":
                return renderImport()
            case 'notes':
                return renderNotes()
            case 'history':
                return renderHistory()
            case 'bulk_edit':
                return renderBulkEdit()
            case 'bulk_edit_services':
                return renderBulkEditServices()
            default:
                return renderDashboard()
        }
    }

    const renderHistory = () => {
        return (
            <>
                <h1>Billable Account's History</h1>
                <BillableAccountHistory scopedByClient={scopedByClient} />
            </>
        )
    }

    function setUpCableConnection() {
        consumer.subscriptions.create(
            {
                channel: "BillableAccountNotesAlertConnectionChannel",
                connection_id: billableAccountId,
            },
            {
                connected: () => {},
                disconnected: (a, b, c) => {
                    // console.log("a: ", a, " b: ", b, " c: ", c)
                },
                received: (data) => {
                    console.log(data)
                    processBillableAccountNoteResponse(data.alert_active)
                },
            }
        )
        
    }
    const renderDashboard = () => {
        return <Dashboard scopeType="BillableAccount" scopeId={billableAccountId} clientId={clientId} />
    }

    const renderIndex = () => {
        if (scopedByClient) {
            return (
                <>
                    <BillableAccountTable scopedByClient={scopedByClient} />
                </>
            )
        }

        return <BillableAccountTable scopedByClient={scopedByClient} />
    }

    const renderForm = () => {
        if (recordSelected) {
            return (
                <>
                    <h1>Edit Form</h1>
                    <BillableAccountForm actionName="edit" />
                </>
            )
        }

        return (
            <>
                <h1>New Form</h1>
                <BillableAccountForm actionName="new" />
            </>
        )
    }

    const renderServices = () => {
        return (
            <>
                <h1>Billable Account's Services</h1>
                <ServiceTable scopedByClient={scopedByClient} />
            </>
        )
    }

    const renderServiceForm = () => {
        if (recordSelected) {
            return (
                <>
                    <h1>Edit Form</h1>
                    <ServiceForm actionName="edit" scopedByBillableAccount={true} />
                </>
            )
        }

        return (
            <>
                <h1>New Form</h1>
                <ServiceForm actionName="new" scopedByBillableAccount={true} />
            </>
        )
    }

    const renderDocuments = () => {
        return <DocumentsTable type="BillableAccount" id={billableAccountId} display="Billable Account" />
    }

    const renderDocumentsForm = () => {
        return <DocumentForm type="BillableAccount" id={billableAccountId} />
    }

    const renderBills = () => {
        return <BillTable scopedByClient={scopedByClient} accountType={"billable_account"} accountId={billableAccountId} />
    }

    const renderImport = () => {
        return <ImportForm dataType="billableAccount" />
    }

    const renderBulkEdit = () => {
        return <BulkEditForm key="billableAccount" dataType="billableAccount" />
    }

    const renderBulkEditServices = () => {
        return <BulkEditForm key="service" dataType="service" />
    }

    const renderNotes = () => {
        return <BillableAccountNotesTable scopedByClient={scopedByClient} />
    }

    return <>{renderView()}</>
}